var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"overlay-no-events"},[(_vm.active && _vm.viewType === '2D')?_c('crop-2D',{attrs:{"view-id":_vm.viewId}}):_vm._e(),(_vm.active && _vm.viewType === '3D')?_c('crop-3D',{attrs:{"view-id":_vm.viewId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }